const editorErrorMessages = {
  NO_SUBSCRIPTION_WIDGET_IN_LINKS: 'You must add a subscription link to your page first',
  NO_SUBSCRIPTION_WIDGET_IN_LINKS_FOR_PART_OF_SUBSCRIPTION_TYPE: 'To publish your content as part of a subscription, you must add a subscription link to your page first',
  STRIPE_ACCOUNT_NOT_CREATED: 'You must set up a paid subscription first',
  NO_SUBSCRIPTION_WIDGET_IN_LINKS_AND_STRIPE_ACCOUNT_NOT_CREATED: 'You must set up a paid subscription and add a subscription link to your page',
  DEFAULT_UNEXPECTED_ERROR: 'Something went wrong, please contact our support',
  YOU_HAVE_ALREADY_SENT_MESSAGES: 'You have already sent messages',
};


export default editorErrorMessages;
